import React from "react";
import { useTranslation } from "react-i18next";

export const TrialCreateAccountSidebarStepContent: React.FC = () => {
    const { t } = useTranslation("getting-started");

    return <p>{t("select-plan.sidebar-content-dts-false")}</p>;
};
